export const FacebookRound = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='12' fill='#3A559F' fillOpacity='0.1'></circle>
        <path
          fill='#3A559F'
          fillRule='evenodd'
          d='M12.812 16.923H10.63v-4.65H9.54v-1.79h1.09V9.406c0-1.46.616-2.33 2.365-2.33h1.457V8.87h-.91c-.682 0-.727.25-.727.717l-.003.896h1.65l-.193 1.792h-1.457v4.65z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
